import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import styled from 'styled-components';
import SbEditable from 'storyblok-react';
import LinkWrap from '../link_wrap';

const Category = (props) => {
  return (
    <div>
      <CategoryTitle>{props.title}</CategoryTitle>
      {props.jobs.map((j) => (
        <JobLink>
          <LinkWrap to={j.slug}>{j.title}</LinkWrap>
        </JobLink>
      ))}
    </div>
  );
};

const JobList = (props) => {
  const jobs = [...props.data?.allStoryblokEntry?.edges]
    .sort((a, b) => {
      const category = a.node.field_category_string.localeCompare(b.node.field_category_string);

      if (category !== 0) {
        return category;
      }

      return a.node.field_title_string.localeCompare(b.node.field_title_string);
    })
    .map((j) => {
      return {
        title: j.node.field_title_string,
        category: j.node.field_category_string,
        datePosted: j.node.published_at,
        slug: j.node.full_slug,
      };
    })
    .reduce((result, job) => {
      result[job.category] = [...(result[job.category] || []), job];
      return result;
    }, {});

  return (
    <SbEditable content={props.blok}>
      <div>
        {Object.keys(jobs).length === 0 && <h5>There are no open positions at this time.</h5>}
        {Object.keys(jobs).map((c, idx) => (
          <Category title={c} jobs={jobs[c]} key={`category-${idx}`} />
        ))}
      </div>
    </SbEditable>
  );
};

const CategoryTitle = styled.h3`
  margin-top: 2rem;
`;

const JobLink = styled.span`
  display: block;
  font-size: 1.2rem;
`;

export default (props) => (
  <StaticQuery
    query={graphql`
      {
        allStoryblokEntry(
          filter: { field_component: { eq: "job_post" }, field_visible_boolean: { eq: true } }
        ) {
          edges {
            node {
              id
              name
              full_slug
              field_category_string
              field_title_string
              published_at
            }
          }
        }
      }
    `}
    render={(data) => <JobList data={data} {...props} />}
  />
);
